// extracted by mini-css-extract-plugin
export default {"notFound":"CWUDjrWECVKEziiezNEK","title":"CNYobe6P6vVNZa8BLf2g","desc":"tjvE89cWTJgKShQpiruG"};